import React, { PureComponent } from 'react';
import { GenericEditPanel } from 'com-gyf-webcore-userinterfacecomponents';

class Agrupamientos extends PureComponent {
    constructor(props) {
        super(props);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     */
    actualizarNovedadEstado(novedad, estadoId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, this.props.cuentaTarjetaId)
    }
    /**
     * 
     * @param {any} event
     */
    selectCombo(event) {
        this.props.selectCombo(1, this.props.codigoNovedad, event.target.value)
    }
    /**
     * 
     */
    render() {
        const { codigoNovedad, cuentaTarjetaId, data, esNovedadEditada,
            funcionesDelUsuario, novedades, seEstaEditando, agrupamientos,
            cuentaTarjetaEstadoId } = this.props;

        let agrupamientoVisaId = (data.agrupamientoVisaId || 0);
        let agrupamientoCodigo = "Sin especificar";
        let novedad = undefined;

        if (novedades && novedades.length > 0) {
            /*Busco el max id de las novedades generadas*/
            const novedadId = Math.max(...novedades.map(n => n.Id));
            /*Obtengo esa novedad*/
            novedad = novedades.find(n => n.Id == novedadId);

            if (novedad) {
                if (esNovedadEditada == false) {
                    agrupamientoVisaId = novedad.ValorNovedad;
                }

                novedad.ValorAnteriorFormateado = "Sin especificar";
            }
        }

        agrupamientos.forEach(s => {
            if (s.Id == agrupamientoVisaId) {
                agrupamientoCodigo = s.Descripcion;
            }

            if (novedad) {
                if (s.Id == novedad.ValorAnterior) {
                    novedad.ValorAnteriorFormateado = s.Descripcion;
                }
            }
        });

        const componente = (
            <select className="form-control default-select" value={agrupamientoVisaId} onChange={this.selectCombo.bind(this)}>
                <option value="0">Seleccione...</option>
                {(agrupamientos || []).map((model, index) => {
                    return (
                        <option value={model.Id} key={"modelo-option-" + index} data-codigo={model.Codigo}>
                            {model.Descripcion}
                        </option>
                    );
                })}
            </select>
        );

        /*si es Seleccionar no lo guardo*/
        const error = (agrupamientoVisaId == 0);

        return (
            <GenericEditPanel
                componente={componente}
                cuenta={{ CuentaTarjetaEstadoId: cuentaTarjetaEstadoId }}
                error={error}
                novedad={novedad}
                permisoUsuario={funcionesDelUsuario}
                seEstaEditando={seEstaEditando}
                textPanel={agrupamientoCodigo}
                title="Agrupamientos"
                value={agrupamientoVisaId}

                aceptChanges={(value) => this.props.guardarNovedad(value)}
                confirmarNovedad={() => this.actualizarNovedadEstado(novedad, 2)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(novedad, 3)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar}
            />
        );
    }
}

export default Agrupamientos;